import {
  useColorScheme,
  useTheme,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

export const PillIconComponent = ({
  fontSize,
  color,
  margin,
}) => {
  const theme = useTheme();
  const { mode } = useColorScheme();
  const paletteForMode = theme.colorSchemes?.[mode]?.palette || theme.palette;
  const iconColor = paletteForMode.text?.primary || theme.palette.text?.primary;
  return (
    <svg
      style={{
        width: fontSize,
        height: fontSize,
        color: color || iconColor,
        margin,
      }}
      viewBox="0 0 24 24"
    ><path fill="currentColor" d="m4.22 11.29l7.07-7.07a6.011 6.011 0 0 1 8.49 0c2.34 2.34 2.34 6.14 0 8.49l-7.07 7.07c-2.35 2.34-6.15 2.34-8.49 0a6.011 6.011 0 0 1 0-8.49m1.42 1.42a3.976 3.976 0 0 0-1.04 3.86l5.99-5.98l4.24 4.24l3.53-3.54a3.978 3.978 0 0 0 0-5.65a3.978 3.978 0 0 0-5.65 0l-7.07 7.07Z" />
    </svg>
  );
}

PillIconComponent.propTypes = {
  fontSize: PropTypes.number,
  color: PropTypes.string,
  margin: PropTypes.string,
};

PillIconComponent.defaultProps = {
  fontSize: 24,
  color: null,
  margin: '0',
};

export default PillIconComponent;
